import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { usePageConfig } from '@/contexts/PageConfigContext';
import { ContentLayout } from '@/layouts/ContentLayout';
import AllLeaguesTab from '@/pages/leagues-list/AllLeaguesTab';
import MatchesByDateTab from '@/pages/leagues-list/MatchesByDateTab';

/**
 * Layout for the `/matches` section: configures the AppLayout shell and hosts
 * two tabs — date-first matches (`/matches`, default) and the league index
 * (`/matches/leagues`). Each tab owns its own query.
 */
const LeaguesListLayout: React.FC = () => {
  const { t } = useTranslation('league');

  usePageConfig({
    title: t('matchesTitle'),
    headerSolid: true,
  });

  const tabs = useMemo(() => ([
    { component: MatchesByDateTab, path: '/matches' },
    { component: AllLeaguesTab, path: '/matches/leagues' },
  ]), []);

  return <ContentLayout sidebar={null} tabs={tabs} />;
};

export default LeaguesListLayout;
